import moment from "moment";
import { useEffect, useState } from "react";
import { AiFillDelete, AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
	deleteManyTask,
	deleteTask,
	loadAllTaskPaginated,
} from "../../../redux/rtk/features/crm/task/crmTaskSlice";
import ViewBtn from "../../Buttons/ViewBtn";
import UserPrivateComponent from "../../PrivateRoutes/UserPrivateComponent";
import CreateDrawer from "../CommonUi/CreateDrawer";
import CrmSearch from "../CommonUi/CrmSearch";
import TableComponent from "../CommonUi/TableComponent";
import CreateTaskForm from "./CreateTaskForm";
import CustomDrawer from "../CommonUi/CustomDrawer";
import CreateTask from "./CreateTask";


const Tasks = () => {
	const dispatch = useDispatch();
	// Drawer state
	const [open, setOpen] = useState(false);
	const onClose = () => {
		setOpen(false);
	};
	// filter
	const [isFilter, setFilter] = useState(false);
	const filterToggle = () => {
		setFilter((prev) => !prev);
	};

	useEffect(() => {
		dispatch(loadAllTaskPaginated({ status: true, page: 1, count: 10 }));
	}, [dispatch]);


	let deleteHandler = async (id) => {
		console.log("Delete Id:", id);
		// dispatch(deleteTask(id));
		try {
			const res = await dispatch(deleteTask(id))
			dispatch(loadAllTaskPaginated({ status: true, page: 1, count: 10 }))
		} catch (error) {
			console.error(error)
		}
	};

	const columns = [
		{
			title: "Slot Id",
			dataIndex: "id",
			key: "slotId",
			sorter: (a, b) => a.slotId - b.slotId,
		},
		{
			title: "Franchise Name",
			key: "franchiseName",
			dataIndex: "franchiseName",
			// render: (franchiseName) => {
			// 	return franchiseName || "N/A";
			// }
		},
		{
			title: "Game Room",
			key: "gameName",
			dataIndex: "gameName",
			// render: (gameName) => {
			// 	return gameName || "N/A";
			// }
		},
		{
			title: "Slot No",
			dataIndex: "slotId",
			key: "slotNo",
			sorter: (a, b) => a.slotId - b.slotId,
		},
		{
			title: "Slot Time",
			dataIndex: "taskName",
			key: "taskName",
		},
		{
			title: "Weekdays Cost",
			dataIndex: "slotCostWeek",
			key: "slotCostWeek",
			render: (cost) => `₹${cost}`,
		},
		{
			title: "Weekend Cost",
			dataIndex: "slotCostEnd",
			key: "slotCostEnd",
			render: (cost) => `₹${cost}`,
		},
		{
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id, record) => (
				<div className="flex gap-2">
					<span className="flex items-center gap-2">
						<CreateTask record={record} />
					</span>
					<span
						onClick={() => deleteHandler(record.id)}
						className='p-1 cursor-pointer w-8 h-8 flex justify-center items-center rounded'
					>
						<AiFillDelete className='text-[#EF4444] text-xl' />
					</span>
				</div>
			),
		},

	];

	const { list, loading, total } = useSelector((state) => state.crmTask);

	return (
		<div className='px-4'>
			<div className='bg-white dark:bg-DTableBg flex justify-between items-center gap-3 filter-wrapper border-radius-top table-top-padding'>
				<div className="flex items-center">
					<h2 className="text-xl md:text-2xl font-semibold">Game Slot List</h2>	
				</div>
				<div className="flex flex-col sm:flex-row sm:items-center sm:gap-[12px]">
					<div className='flex flex-col sm:flex-row sm:justify-end sm:items-center gap-5'>
						<button
							onClick={filterToggle}
							className={`hidden md:block ${isFilter ? "btn-secondary" : "btn-secondary rounded-[1.25rem]"
								}  px-5 py-2 rounded cursor-pointer rounded-[1.25rem]`}
							type='submit'>
							{isFilter ? (
								<span className='flex justify-center items-center gap-2'>
									<AiOutlineClose /> Close
								</span>
							) : (
								<span className=''>Filter</span>
							)}
						</button>
						{/* {!isFilter ? (
							<CrmSearch paginatedThunk={loadAllTaskPaginated} />
						) : (
							<div className='flex text-md'>
							</div>
						)} */}
					</div>
					{!isFilter && (
						// <UserPrivateComponent permission='create-quote'>
							<button
								onClick={() => setOpen(true)}
								className='py-2 px-6 btn-primary cursor-pointer flex items-center gap-2 w-max text-[10px] md:text-[14px]'>
								<AiOutlinePlus /> Add New Slot 
							</button>
						// </UserPrivateComponent>
					)}
				</div>
			</div>
			<UserPrivateComponent permission='readAll-crmTask'>
				<TableComponent
					list={list}
					total={total}
					loading={loading}
					columns={columns}
					paginatedThunk={loadAllTaskPaginated}
					deleteManyThunk={deleteManyTask}
					csvFileName={"Task-List"}
					pagination={{
						defaultPageSize: 20,
					}}
				/>
			</UserPrivateComponent>

			<UserPrivateComponent permission='create-crmTask'>
				<CreateDrawer onClose={onClose} open={open} title={"Add New Slot "}>
					<CreateTaskForm onClose={onClose} open={open} total={total} />
				</CreateDrawer>
			</UserPrivateComponent>
		</div>
	);
};
export default Tasks;
